import { Injectable, Pipe, PipeTransform } from "@angular/core";
import { Permission } from "../../common/enums/permission.enum";
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { UserInfo } from '../../shared/interface/user-info.interface';
import { CacheService } from "../../shared/services/cache.service";
@Pipe({
    name: 'hasAuthority'
})

@Injectable()
export class AuthorizationPipe implements PipeTransform {
constructor(private _cacheService:CacheService){}
    transform(value: any, isStore?: Boolean, storeId?: Number): Boolean {

        if (value instanceof Array) {
       let userInfo:UserInfo = this._cacheService.get(CacheKey.UserInfo);
      if (userInfo && userInfo.hasSystemRole) {
        return true;
      }
      else if (isStore && userInfo && storeId && storeId > 0) {
        let manageStorePermissions: Number[] = [Permission.MANAGE_STORE_CREATE, Permission.MANAGE_STORE_VIEW, Permission.MANAGE_STORE_EDIT, Permission.MANAGE_STORE_DELETE];
        let userStorePermissions: any[] = userInfo.privileges.stores;
        let userAccountPermissions: any[] = userInfo.privileges.account;
        if (userAccountPermissions && userAccountPermissions.length > 0 && userAccountPermissions.some(item => value.indexOf(item) >= 0)) {
          return true;
        }
        else if (userStorePermissions && userStorePermissions.length > 0) {
          let store = userStorePermissions.filter(item => item.id === storeId)[0];
          if (store) {
            return store.permissions.some((item: any) => value.indexOf(item) >= 0);
          }
          else {
            return false;
          }
        }
        else {
          return false;
        }
      }
      else {
        if (userInfo && userInfo.privileges) {
          let userAccountPermissions: any[] = userInfo.privileges.account;
          if (userAccountPermissions && userAccountPermissions.length > 0 && userAccountPermissions.some(item => value.indexOf(item) >= 0)) {
            return true;
          }
          else {
            return false;
          }
        }
      }
    }
    else {
      return false;
    }
    }
}


// WEBPACK FOOTER //
// ./src/app/common/pipes/authorization.pipe.ts